export default "__VITE_ASSET__PffVycR$__"